import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PageHeader = ({ eyebrow, title, description, actionLabel, actionTo, actionOnClick }) => (
  <div className="flex flex-col gap-4 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm lg:flex-row lg:items-end lg:justify-between">
    <div className="space-y-2">
      {eyebrow ? <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#096dea]">{eyebrow}</p> : null}
      <h1 className="text-2xl font-semibold text-slate-950 lg:text-3xl">{title}</h1>
      {description ? <p className="max-w-2xl text-sm leading-6 text-slate-600">{description}</p> : null}
    </div>
    {actionLabel ? (
      actionTo ? (
        <Link to={actionTo} className="inline-flex items-center gap-2 justify-center rounded-xl bg-[#096dea] px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0959bb]">
          <ArrowLeft size={16} />
          {actionLabel}
        </Link>
      ) : (
        <button type="button" onClick={actionOnClick} className="inline-flex items-center gap-2 justify-center rounded-xl bg-[#096dea] px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0959bb]">
          <ArrowLeft size={16} />
          {actionLabel}
        </button>
      )
    ) : null}
  </div>
);

export default PageHeader;
